import React, { useState } from 'react';
import CommodityList from '@/components/Commodity/MaintainCommodity';
// import BookingForm from '@/components/booking/BookingForm';
// import BookingPrint from '@/components/booking/BookingPrint';

const Commodity = () => {
    const [view, setView] = useState('list'); // list | form | print
    const [selectedShipment, setSelectedShipment] = useState(null);

    const handleCreateNew = () => {
        setSelectedShipment(null);
        setView('form');
    };

    const handleViewShipment = (shipment) => {
        setSelectedShipment(shipment);
        setView('form');
    };

    const handlePrintShipment = (shipment) => {
        setSelectedShipment(shipment);
        setView('print');
    };

    const handleBackToList = () => {
        setSelectedShipment(null);
        setView('list');
    };

    const handleBackToForm = () => {
        setView('list');
    };

    return (
        <div className="h-full p-4">
            {view === 'list' && (
                <CommodityList
                    onCreateNew={handleCreateNew}
                    onViewShipment={handleViewShipment}
                    onPrintShipment={handlePrintShipment}
                />
            )}

            {/* {view === 'form' && (
                <BookingForm
                    bookingData={selectedShipment}
                    onBack={handleBackToList}
                    onPrint={handlePrintShipment}
                />
            )}

            {view === 'print' && (
                <BookingPrint
                    bookingData={selectedShipment}
                    onBack={handleBackToForm}
                />
            )} */}
        </div>
    );
};

export default Commodity;
